module.exports = __webpack_public_path__ + "static/media/uae-banner-mobo.732af003.png";